import { fileURL } from "@src/Plasmids/domain/plasmid";
import browserDetect from "@src/Plasmids/utils/browserDetect";

function openSequenceChrome(url) {
	const customLinkName = "temporaryAnchor";
	const existingLink = document.getElementById(customLinkName);
	if (existingLink) {
		existingLink.parentNode.removeChild(existingLink);
	}
	const anchor = document.createElement("a");
	anchor.href = url;
	anchor.innerHTML = customLinkName;
	anchor.setAttribute("id", customLinkName);
	anchor.setAttribute("style", "display:none;");
	anchor.setAttribute("target", "");
	document.body.appendChild(anchor);

	const createdLink = document.getElementById(customLinkName);
	if (createdLink === null || createdLink === undefined) return;

	let triggered = false;

	if (createdLink.dispatchEvent) {
		const event = new MouseEvent("click", {
			bubbles: true,
			cancelable: true,
			view: window,
		});

		if (createdLink.dispatchEvent(event)) triggered = true;
	}

	if (!triggered && createdLink.click) {
		createdLink.click();
	}
}

const openSequence = (url) => {
	const browser = browserDetect();

	// Safari, Chrome, Opera 15+
	if (browser === "Safari" || browser === "Chrome" || browser === "Opera") {
		openSequenceChrome(url);
	}
	// Firefox
	else if (browser === "Firefox") {
		openSequenceChrome(url);
	}
	// Internet Explorer
	else if (browser === "IE") {
		openSequenceChrome(url);
	}
	// Microsoft Edge
	else if (browser === "Edge") {
		openSequenceChrome(url);
	} else {
		// console.log("[openSequence, browser]", browser);
	}
};

export const setProtocol = (protocol, props) => {
	const { plasmidName, filePath } = props;
	const lastURL = fileURL(protocol, plasmidName, filePath);
	openSequence(lastURL);
};
